import React from 'react';
import { Container } from './ui/Container';
import { BonoItem } from './BonoItem';
import { bonos } from '../data/bonos';
export function BonosSection() {
  return <section className="bg-mp-dark py-16 md:py-24 border-t border-mp-border" data-id="element-37" data-mp="1870cbjpu3ejf">
      <Container data-id="element-38" data-mp="13c2zs2tcin1s">
        <div className="max-w-[700px]" data-id="element-39" data-mp="13bl0syfatuq6">
          <p className="font-heading text-xs uppercase tracking-[0.2em] text-mp-electric" data-id="element-40" data-mp="ydrt20ycksns">
            Los 5 bonos de implementación
          </p>
          <p className="mt-1 text-sm text-mp-gray" data-id="element-41" data-mp="tdndqe96e3z5">Incluidos gratis con Maestro en Pista.</p>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-42" data-mp="oizv2w0us3sh">
          {bonos.map((bono, index) => <BonoItem key={bono.number} bono={bono} index={index} data-id="element-43" data-mp="fgi6wc1n112u" data-mpi={index} />)}
        </div>
      </Container>
    </section>;
}